export const CASH = 'cash';
export const BANK = 'bank';
export const ACQUIRING = 'acquiring';
export const YOOKASSA = 'yookassa';
export const WAREHOUSE_1C = 'warehouse-1c';
export const LOYALTY = 'loyalty';

export const CASH_LABEL = 'Наличные';
export const BANK_LABEL = 'Расчётный счёт';
export const ACQUIRING_LABEL = 'Эквайринг';
export const WAREHOUSE_1C_LABEL = 'Интеграция 1С';

export const PAY_TYPES = [
  {
    label: <span data-testid="cash-payment">{CASH_LABEL}</span>,
    value: CASH,
    filterName: CASH_LABEL,
  },
  {
    label: <span data-testid="bank-account-payment">{BANK_LABEL}</span>,
    value: BANK,
    filterName: BANK_LABEL,
  },
];
